require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-age-friendly-communities.json") })
        }
      }, "path---projects-age-friendly-communities");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-age-friendly-communities!./.cache/json/projects-age-friendly-communities.json
// module id = 340
// module chunks = 231608221292675